import type { CustomAccordionProps } from '@/types';
import type { FC } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const CustomAccordion: FC<CustomAccordionProps> = ({
  type = 'single',
  items,
  className,
  AccordionTriggerClassName,
  isAllExpanded,
  defaultValue,
  accordionItemClassName,
  value,
  onValueChange,
  accordionContentClassName,
}) => {
  const accordionItems = items.map(({ value, title, content, isDisabled }) => (
    <AccordionItem className={accordionItemClassName} key={value} value={value}>
      <AccordionTrigger className={AccordionTriggerClassName} disabled={isDisabled}>
        {title}
      </AccordionTrigger>
      {!isDisabled && (
        <AccordionContent className={accordionContentClassName}>{content}</AccordionContent>
      )}
    </AccordionItem>
  ));

  if (isAllExpanded) {
    return (
      <Accordion
        type="multiple"
        className={className}
        defaultValue={items.map(({ value }) => value)}
      >
        {accordionItems}
      </Accordion>
    );
  }

  const getAccordionProps = () => {
    if (type === 'single') {
      return {
        type: 'single' as const,
        collapsible: true,
        value: value as string | undefined,
        defaultValue: defaultValue as string | undefined,
        onValueChange: onValueChange as ((value: string) => void) | undefined,
      };
    } else {
      return {
        type: 'multiple' as const,
        value: value as string[] | undefined,
        defaultValue: defaultValue as string[] | undefined,
        onValueChange: onValueChange as ((value: string[]) => void) | undefined,
      };
    }
  };

  return (
    <Accordion {...getAccordionProps()} className={className}>
      {accordionItems}
    </Accordion>
  );
};

export default CustomAccordion;
